import { selectAccountId } from '@socialive/common';
import { Button, Form, Modal, SelectField } from '@socialive/ui';
import PropTypes from 'prop-types';
import { useCallback, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { selectAccountChannelsSorted } from '~/store';

const openRecorder = ({ accountId, channelToken, channelName }) => {
  const windowType = sessionStorage.getItem('studioWindowType');
  const url = new URL(sessionStorage.getItem('studioURLOverride'));

  url.searchParams.set('accountId', accountId);
  url.searchParams.set('channelToken', channelToken);
  url.searchParams.set('channelName', channelName);

  const windowParams =
    windowType !== 'tab'
      ? `width=${window.screen.availWidth},height=${window.screen.availHeight},titlebar=no,menubar=no,status=no`
      : '';

  window.webcasterWindow = window.open(url.href, 'webcaster', windowParams);
};

const CreateRecordingModal = ({ modal }) => {
  const accountId = useSelector(selectAccountId);
  const accountChannels = useSelector(selectAccountChannelsSorted);

  const channelOptions = useMemo(
    () => accountChannels.map(({ token, name }) => ({ value: token, label: name })),
    [accountChannels]
  );
  const form = useForm({ defaultValues: { channelToken: channelOptions[0].value } });

  const onSubmit = useCallback(
    async (values) => {
      const { channelToken } = values;
      const { name: channelName } = accountChannels.find(({ token }) => token === channelToken);
      openRecorder({ accountId, channelToken, channelName });
      modal.close({ action: 'Submit', trigger: 'NeRecordingModal@onSubmit' });
    },
    [accountChannels, accountId, modal]
  );

  return (
    <Modal title="Create Recording" visible onCancel={modal.close} width={520} onCloseButtonClick={modal.close}>
      <Form form={form} onSubmit={onSubmit} className="flex flex-col gap-2 m-0.5">
        <SelectField name="channelToken" label="Channel" options={channelOptions} />
        <div className="flex justify-between">
          <Button context="subtle" onClick={modal.close}>
            Cancel
          </Button>
          <Button context="primary" type="submit">
            Done
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

CreateRecordingModal.propTypes = {
  modal: PropTypes.shape({
    visible: PropTypes.bool,
    open: PropTypes.func,
    update: PropTypes.func,
    close: PropTypes.func,
  }).isRequired,
};

export default CreateRecordingModal;
